<h4 mat-dialog-title><i class="fas fa-plus mr-1"></i> Add Zone</h4>

<mat-dialog-content class="mat-typography">
    <div>
        <form class="w-100 input-content" [formGroup]="form">
            <mat-form-field class="w-100">
                <mat-label>Zone ID</mat-label>
                <input type="number" matInput formControlName="zoneId">
            </mat-form-field>

            <mat-form-field class="w-100">
                <mat-label>Zone Name</mat-label>
                <input maxlength="35" type="text" matInput formControlName="zoneName">
            </mat-form-field>

            <mat-form-field class="w-100">
                <mat-label>Parking Type</mat-label>
                <mat-select formControlName="parkingType" (selectionChange)="showhideField()">
                  <mat-option value="1">Paid</mat-option>
                  <mat-option value="2">Permitted</mat-option>
                </mat-select>
                <!-- <input type="text" matInput formControlName="parkingType"> -->
            </mat-form-field>

            <div id="hiddenField" class="d-none">

            <mat-form-field class="w-100">
                <mat-label>Parking Service</mat-label>
                <mat-select formControlName="description">
                    <mat-option value="Flowbird">Flowbird</mat-option>
                    <mat-option value="Parkmobile">Parkmobile</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="w-100">
                <mat-label>Duration (Minutes)</mat-label>
                <input type="number" matInput formControlName="duration">
            </mat-form-field>

            <mat-form-field class="w-100">
                <mat-label>Grace Period (Minutes)</mat-label>
                <input type="number" matInput formControlName="gracePeriod">
            </mat-form-field>

            <mat-form-field class="w-100">
                <mat-label>Multiple Ticket</mat-label>
                <mat-select formControlName="multipleTicket">
                  <mat-option value="true">Yes</mat-option>
                  <mat-option value="false">No</mat-option>
                </mat-select>
                <!-- <input type="text" matInput formControlName="multipleTicket"> -->
            </mat-form-field>
            </div>

            <!-- <div class="float-left">
                <mat-label>Is Active:</mat-label>
            </div>
            <div class="float-left ml-2" style="margin-top: 0.15rem;">
                <input type="checkbox" formControlName="status" [(ngModel)]="isStatus">
            </div> -->
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-success float-right mr-2" type="submit" [disabled]="!form.valid" (click)="addZoneData()">
        <i class="fas fa-plus mr-1"></i> Add</button>
    <button class="btn btn-light float-right" (click)="closeDialog()">
        <i class="fas fa-times mr-1"></i> Cancel</button>
</mat-dialog-actions>